import axios from "axios";
import get from "lodash/get";

// The CRM rejects leads without a valid email; forms that only ask for a phone use this.
const NO_EMAIL = "no_email@no.mail";

const submitContactForm = async (data) => {
  const {
    name = "N/A",
    email = NO_EMAIL,
    phone = "N/A",
    message = "N/A",
    type = "N/A",
    company = "N/A",
    media_code = "N/A",
    departure_date = "N/A",
    arrival_date = "N/A",
    date_of_birth = "N/A",
    passport = "N/A",
    product_type = "N/A"
  } = data;
  const payload = {
    cx_name: name || "N/A",
    cx_email: email || NO_EMAIL,
    cx_mobile: phone || "N/A",
    cx_message: message || "N/A",
    cx_company: company || "N/A",
    inquiry_type: "testing",
    inquiry_media: "INME-WEB",
    inquiry_code: "INME-WEB",
    promo_code: "no-promo",
    media_code: media_code || "N/A",
    product_type: product_type || "N/A",
    insurance_type: type || "N/A",
    form_data: {
      departure_date: departure_date || "N/A",
      arrival_date: arrival_date || "N/A",
      passport_number: passport || "N/A",
      date_of_birth: date_of_birth || "N/A",
    },
  };
  if (data.main_category === "Motor") {
    delete payload.form_data;
    payload.main_category = data.main_category;
    payload.sub_category = data.sub_category;
    payload.email_body_json = data.email_body_json;
  }
  const res = await axios
    .post(`${process.env.GATSBY_API_URL}/send-mail`, payload)
    .then((res) => {
      return get(res, "data", {});
    })
    .catch((e) => {
      return get(e, "response.status", 404);
    });
  return res;
};

export default submitContactForm;
